import { useState } from 'react';

import { OnboardingHeader } from '../../components/OnboardingHeader';
import { PageHeadline } from '../../components/atoms';
import { BtnTransfer } from './components/BtnTransfer';
import { BtnStartOnboarding } from './components/BtnStartOnboarding';
import { useTranslation } from 'react-i18next';
import { clearTransferStepSession } from './CompanyTransfer/constants';

export const ChoiceObjectives = () => {
  const [openInsertCompany, setOpenInsertCompany] = useState(false);
  const [openOnboarding, setOpenOnboarding] = useState(false);
  const { t } = useTranslation();
  const handleBtnTransfer = () => {
    // Nova transfer: descartar step stale de sessão anterior (evita pular p/ shareholders).
    clearTransferStepSession();
    setOpenInsertCompany(true);
  };

  const handleBtnOnboarding = () => {
    // Nova offshore: limpar step stale de transfer para não contaminar o fluxo.
    clearTransferStepSession();
    setOpenOnboarding(true);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50 lg:flex">
      <div className="w-full box-border lg:pr-[20vw]">
        <div className="mx-auto max-w-7xl px-6 py-8 lg:px-12">
          <OnboardingHeader showLogoutButton />

          <div className="mt-6">
            <PageHeadline
              title={t('titles.ttlChooseObjectives')}
              className="mt-8 shadow-xl"
              gradientFrom="from-primary"
              gradientTo="to-blue-800"
            />
          </div>

          <div className="mt-10 flex justify-center">
            <div className="w-full max-w-3xl rounded-xl bg-white p-8 shadow-sm ring-1 ring-slate-900/5">
              <div className="flex flex-col gap-6 text-center">
                <div className="flex flex-col gap-4 text-center md:flex-row md:justify-center">
                  <BtnStartOnboarding
                    onClick={handleBtnOnboarding}
                    callComponent={openOnboarding}
                    text={t('titles.ttlCreateNewOffshore')}
                  />
                  <BtnTransfer
                    onClick={handleBtnTransfer}
                    callComponent={openInsertCompany}
                    text={t('titles.ttlTransferExistingOffshore')}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="fixed right-0 top-0 hidden h-screen lg:block lg:w-1/5">
        <div className="relative h-screen">
          <img src="/img/image01.png" className="h-full w-full object-cover" alt="" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent" />
          <p className="absolute bottom-[25%] left-6 right-6 text-[32px] font-bold leading-tight text-white">
            {t('labels.lblWeveHelped')}
          </p>
        </div>
      </div>
    </div>
  );
};
